import { AbstractControl, ValidatorFn } from '@angular/forms';

export const nieValidator: ValidatorFn = (control: AbstractControl) => {
  const value = control.value;
  if (!value) return null;

  const match = value.match(/^([XYZ])(\d{7})([A-Z])$/i);
  if (!match) return { invalidNie: true };

  const [, prefix, number, letter] = match;

  const prefixMap: Record<string, string> = { X: '0', Y: '1', Z: '2' };
  const fullNumber = prefixMap[prefix.toUpperCase()] + number;

  const letters = 'TRWAGMYFPDXBNJZSQVHLCKE';
  const expected = letters[+fullNumber % 23];

  return letter.toUpperCase() === expected ? null : { invalidNie: true };
};
